var map = {
	"./BOARD.svg": "ee5e",
	"./CALENDAR.svg": "3e0c",
	"./CARDS.svg": "ff66",
	"./CHARTS.svg": "1581",
	"./GROUP_BY_TABLE.svg": "a2cc",
	"./HTML_CONTENT.svg": "3457",
	"./TABLE.svg": "4505",
	"./TIMELINE.svg": "7cd0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0aa";